export default __webpack_public_path__ + "static/media/covid-19.fi.10a8e8da.png";